import { Block } from "pwapi";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const submissionFieldsForBlock = (
  block: Block,
  values?: Partial<Block>
) => {
  if (!values) values = block;
  return {
    name: values.name,
    piece_count: values.piece_count,
  };
};

export const shallowBlockComparison = (block: Block, values: Block) => {
  const oldValues = submissionFieldsForBlock(block);
  const newValues = submissionFieldsForBlock(block, values);

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForBlock>>(
    oldValues,
    newValues
  );
};
